import HomeInput from '@/components/content/HomeInput';
import ConversationPanelLeft from '@/components/content/ConversationPanelLeft';
import ContentToolbar from '@/coral/components/Content/ContentToolbar';
import {
    Toaster
} from '@fluentui/react-components';
import React, { useCallback } from 'react';
import Content from '../coral/components/Content/Content';
import CoralShellColumn from '../coral/components/Layout/CoralShellColumn';
import CoralShellRow from '../coral/components/Layout/CoralShellRow';
import '../styles/PlanPage.css';

/**
 * HomePage component - displays task lists and provides navigation
 * Accessible via the route "/"
 */
const HomePage: React.FC = () => {
    /**
     * Handle new task creation from input submission - placeholder for future implementation
     */
    const handleNewTask = useCallback((taskName: string) => {
        console.log('Creating new task:', taskName);
    }, []);

    return (
        <>
            <Toaster toasterId="toast" />
            <CoralShellColumn>
                <CoralShellRow>
                    <ConversationPanelLeft />
                    <Content>
                        <ContentToolbar
                            panelTitle={"Public Cloud Intelligent Assistant"}
                        ></ContentToolbar>
                        <HomeInput
                            onInputSubmit={handleNewTask}
                            onQuickTaskSelect={handleNewTask}
                        />
                    </Content>

                </CoralShellRow>
            </CoralShellColumn>
        </>
    );
};

export default HomePage;
